import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Row, Col, Select, Checkbox} from 'antd';

import get from 'lodash/get';
import { connect } from 'react-redux';

import {updateFinancePriceRequest, createFinancePriceRequest, getFinanceEventsList} from "../../api/requests";

import {
  getFinanceCreatePermission,
  getFinanceUpdatePermission
} from "../../reducers/user/selectors";

import classes from './FinancePriceForm.css';
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from 'react-i18next';

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class FinancePriceForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showID: false,
      eventList: [],
    };
  }

  componentDidMount() {
    this.getFinanceEventList();
  }

  getFinanceEventList = async () => {
    const { data } = await getFinanceEventsList();
    this.setState({
      eventList: data,
    });
  };

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const item = {...values};

          if (this.props.id) {
            await updateFinancePriceRequest(this.props.id , item);
          } else {
            await createFinancePriceRequest(item);
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: this.props.i18n.t('Success') } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  render() {
    const { isLoading, requestResult, eventList } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { financeUpdatePermission, financeCreatePermission, id, isNew, sites } = this.props;

    const isEditable = id ? financeUpdatePermission : financeCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.name} <Badge count={this.props.i18n.t('Edit')} style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? this.props.i18n.t('NamespaceFinancePriceForm:Add event') : ''}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceFinancePriceForm:Event name')}:</b>
                <Form.Item>
                  {getFieldDecorator('event_id', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'event_id', '')
                  })(
                    <Select disabled={!isEditable}>
                      {eventList.map(({ id, name }) => (
                        <Option value={id} key={id}>
                          {name}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceFinancePriceForm:Event price')}:</b>
                <Form.Item>
                  {getFieldDecorator('price', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'price', '')
                  })(
                    <Input disabled={!isEditable} placeholder={this.props.i18n.t('NamespaceFinancePriceForm:Event price')} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceFinancePriceForm:Event price currency')}</b>
                <Form.Item>
                  {getFieldDecorator('price_currency', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'price_currency', '')
                  })(
                    <Select disabled={!isEditable}>
                      <Option value="CAD">CAD</Option>
                      <Option value="USD">USD</Option>
                      <Option value="EUR">EUR</Option>
                      <Option value="AUD">AUD</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t('NamespaceFinancePriceForm:Price type')}:</b>
                <Form.Item>
                  {getFieldDecorator('price_type', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'price_type', '')
                  })(
                    <Select disabled={!isEditable}>
                      <Option value="general">{this.props.i18n.t('NamespaceFinancePriceForm:General')}</Option>
                      <Option value="per_site">{this.props.i18n.t('NamespaceFinancePriceForm:Per site')}</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            {getFieldValue('price_type') === 'per_site' && <Col span={12}>
              <label>
                <b>{this.props.i18n.t('Site ID')}</b>
                <Form.Item>
                  {getFieldDecorator('site_id', {
                    rules: [{ required: true, message: this.props.i18n.t('Required') }],
                    initialValue: get(this.props, 'site_id')
                  })(<Select  disabled={!isEditable} placeholder={this.props.i18n.t('Select Site ID')} style={{ width: '100%'}} allowClear>
                    {sites.map(site => (
                      <Option key={site.id} value={site.id}>{site.name}</Option>
                    ))}
                  </Select>)}
                </Form.Item>
              </label>
            </Col>}
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                {this.props.i18n.t('Save')}
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              {this.props.i18n.t('Cancel')}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  financeCreatePermission: getFinanceCreatePermission(state),
  financeUpdatePermission: getFinanceUpdatePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'financePriceForm' })(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(FinancePriceForm)));



// WEBPACK FOOTER //
// ./src/components/FinancePriceForm/FinancePriceForm.js